/**
 * Customer Master Parser
 * Transforms customer master API responses into a consistent format
 */

export const parseCustomerMaster = (customer) => {
    if (!customer) return null;

    return {
        id: customer.id,
        name: customer.name,
        mobile: customer.mobile,
        email: customer.email,
        address: customer.address,
        city: customer.city,
        state: customer.state,
        pincode: customer.pincode,
        landmark: customer.landmark,
        notes: customer.notes,
        is_active: customer.is_active,
        created_at: customer.created_at,
        updated_at: customer.updated_at,
        created_by: customer.created_by,
        region: customer.region,
        stats: customer.stats,
        source: customer.source,
        app_account: customer.app_account || null,
    };
};

export const parseCustomerMasterDetails = (response) => {
    if (!response?.success || !response?.result) {
        return null;
    }

    const { customer, creation_source, orders, warranty_registrations, insurance_renewals, summary } = response.result;

    return {
        customer: parseCustomerMaster(customer),
        creation_source,
        orders: {
            data: orders?.data || [],
            stats: orders?.stats || {},
        },
        warranty_registrations: {
            data: warranty_registrations?.data || [],
            stats: warranty_registrations?.stats || {},
        },
        insurance_renewals: {
            data: insurance_renewals?.data || [],
            stats: insurance_renewals?.stats || {},
        },
        summary,
    };
};

export const parseCustomerMasterList = (response) => {
    if (!response?.success || !response?.result) {
        return {
            results: [],
            count: 0,
            pagination: {
                page: 1,
                limit: 10,
                totalPages: 1,
            },
        };
    }

    const { results, count, pageNo, limit } = response.result;

    return {
        results: (results || []).map(parseCustomerMaster),
        count: count || 0,
        pagination: {
            page: (pageNo || 0) + 1, // Convert 0-based to 1-based
            limit: limit || 10,
            totalPages: Math.ceil((count || 0) / (limit || 10)),
        },
    };
};

export const parseCustomerMasterStats = (response) => {
    if (!response?.success || !response?.result) {
        return {
            total_customers: 0,
            staff_created_customers: 0,
            total_orders: 0,
            total_warranty_registrations: 0,
            total_insurance_renewals: 0,
        };
    }

    return response.result;
};

export const parseCustomerDeletionImpact = (response) => {
    if (!response?.success || !response?.result) {
        return null;
    }

    return response.result;
};
